import React from 'react';
import { Voucher } from '../../models/voucher.model';
import { usePdfViewer } from '../../contexts/PdfViewerContext';

interface ButtonEntryDocumentsProps {
  vouchers?: Voucher[];
}

const ButtonEntryDocuments: React.FC<ButtonEntryDocumentsProps> = ({ vouchers }) => {
  const { open } = usePdfViewer();

  if (!vouchers || vouchers.length === 0) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const firstDoc = vouchers[0];
    if (firstDoc.id_document_inbox) {
      open(firstDoc.id_document_inbox);
    }
  };

  return (
    <button
      className="btn btn-icon btn-sm btn-light-primary"
      title={`${vouchers.length} document${vouchers.length > 1 ? 's' : ''}`}
      onClick={handleClick}
    >
      <i className="bi bi-paperclip fs-4"></i>
      {vouchers.length > 1 && (
        <span className="badge badge-circle badge-sm badge-primary position-absolute top-0 end-0 translate-middle">{vouchers.length}</span>
      )}
    </button>
  );
};

export default ButtonEntryDocuments;
